<template>
    <div class="max-w-7xl mx-auto mb-8 px-2">
        <div class="flex justify-center">
            <a
                :href="registerUrl"
                target="_blank"
                class="px-4 py-3 rounded-lg2 border border-transparent hover:border-primary hover:bg-blue-50 hover:shadow-xs text-center align-middle text-sm flex items-center gap-1"
            >
                <AppLogoSvg class="w-4 h-4 inline-flex mb-0.5 mr-1" />
                <span class="text-gray-600">
                    {{
                        localizer.translate(
                            TextTokenEnum.BookingForm_WantYourOwnTinyCalBookingPage,
                        )
                    }}
                </span>
                <span class="text-blue-500 text-nowrap flex items-center gap-2">
                    <span>
                        {{
                            localizer.translate(
                                TextTokenEnum.BookingForm_ClickHere,
                            )
                        }}
                    </span>
                    <Icon
                        name="external-link"
                        class="w-3 h-3 inline-flex"
                    />
                </span>
            </a>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {
        UtmSourceEnum,
        UtmMediumEnum,
        UtmContentEnum,
    } from '@/Shared/Service/Tracking/Utm/UtmEnums'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { UtmParameters } from '@/Shared/Service/Tracking/Utm/UtmParameters'
    import { UtmUrlBuilder } from '@/Shared/Service/Tracking/Utm/UtmUrlBuilder'
    import Icon from '@/Shared/Component/Icon.vue'
    import LocalizerService from '@/Shared/Service/Localization/LocalizerService'
    import {
        LocaleEnum,
        TextTokenEnum,
    } from '@/Shared/AutoGenerated/LocalizationEnum'
    import AppLogoSvg from '@/Shared/Component/AppLogoSvg.vue'

    interface FooterProps {
        currentLocale: LocaleEnum
    }

    const props = defineProps<FooterProps>()

    const localizer = LocalizerService.make(props.currentLocale)
    const registerUrl = new UtmUrlBuilder().build(
        new UrlFactory().makeAuthRegisterPageUrl(),
        new UtmParameters(
            UtmSourceEnum.BookingFormFooter,
            UtmMediumEnum.BookingForm,
            UtmContentEnum.BookingFormGetYourOwnPage,
        ),
    )
</script>
